var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M40,21.875A3.244,3.244,0,0,1,36.667,25H3.333A3.244,3.244,0,0,1,0,21.875V3.125A3.244,3.244,0,0,1,3.333,0H36.667A3.244,3.244,0,0,1,40,3.125Z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M36.667,0H3.333A3.244,3.244,0,0,0,0,3.125v18.75A3.244,3.244,0,0,0,3.333,25H36.667A3.244,3.244,0,0,0,40,21.875V3.125A3.244,3.244,0,0,0,36.667,0Zm0,.625a2.59,2.59,0,0,1,2.667,2.5v18.75a2.59,2.59,0,0,1-2.667,2.5H3.333a2.59,2.59,0,0,1-2.667-2.5V3.125A2.59,2.59,0,0,1,3.333.625Z",
    fill: "none",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41",
    transform: "translate(12.141 7.62)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 4.873,
    cy: 4.873,
    r: 4.873,
    transform: "translate(5.973 0.014)",
    fill: "#f79e1b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 4.873,
    cy: 4.873,
    r: 4.873,
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M26.671,17.052a4.866,4.866,0,0,0,1.877,3.856,4.873,4.873,0,0,0,.019-7.7A4.859,4.859,0,0,0,26.671,17.052Z",
    transform: "translate(-20.698 -12.176)",
    fill: "#ff5f00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.7707d0cde408a14bad9ec13ab16f131e.svg";
export { ForwardRef as ReactComponent };